import { useState } from 'react'
import Modal from '@components/ui/Modal'
import { NewsletterModalWrapperStepProps, NewsletterModalProps } from './types'
import NewsletterModalContent from './NewsletterModalContent'
import styles from './styles.module.scss'
import useContentfulImage from '@helpers/hooks/useContentfulImage'

type WrapperState = Record<string, unknown>

export const NEWSLETTER_MODAL_CONTENTFUL_ID = '32yxbFE32TcEuIA9a1Y54L'

type NewsletterModalWrapperProps = {
  steps: {
    component: React.FunctionComponent<NewsletterModalWrapperStepProps>
  }[]
  image?: string
} & NewsletterModalProps

function NewsletterModalWrapper({
  steps,
  openedModal,
  onClose,
  image
}: NewsletterModalWrapperProps) {
  const [activeStep, setActiveStep] = useState(0)
  const [wrapperState, setWrapperState] = useState<WrapperState>({})

  const contentfulImage = useContentfulImage(NEWSLETTER_MODAL_CONTENTFUL_ID)

  const onNextStep = () => {
    setActiveStep(step => step + 1)
  }

  const StepComponent = steps[activeStep].component

  return (
    <Modal
      classes={styles.NewsletterModalWrapper}
      onClose={onClose}
      openedModal={openedModal}
      exclude
    >
      <NewsletterModalContent image={image || contentfulImage}>
        <StepComponent
          onNextStep={onNextStep}
          onClose={onClose}
          setWrapperState={setWrapperState}
          wrapperState={wrapperState}
        />
      </NewsletterModalContent>
    </Modal>
  )
}

export default NewsletterModalWrapper
